import React, { createContext, useContext, useEffect, useState } from "react";
import { getAccessToken } from "../../auth/utils/MsGraphApiCall";

export const HzaContext = createContext({});

export const useHza = () => useContext(HzaContext);

export default function HzaContextProvider({ children }) {
  const [requestStatus, setRequestStatus] = useState({
    isLoading: false,
    done: false,
    name: "",
  });

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data.type === "HZA_REQUEST") {
        const { type, data, name, response } = event.data;

        return setRequestStatus({
          isLoading: false,
          done: true,
          name,
          data,
        });
      }
    };

    window.addEventListener("message", handleMessage);
  }, []);

  const handleRequest = async (api, params, name) => {
    const accessToken = await getAccessToken();
    const hzaIframe = document.getElementById("myFrameHZA").contentWindow;

    if (!hzaIframe) {
      console.error("HZA iframe not found");
      return;
    }

    setRequestStatus({
      isLoading: true,
      done: false,
      name,
      data: null,
    });

    const message = {
      type: "HZA_REQUEST",
      name,
      api,
      params: {
        ...params,
        headers: {
          ...params.headers,
          Authorization: "Bearer ".concat(accessToken),
        },
      },
    };

    hzaIframe.postMessage(message, "*");
  };

  const clearRequestStatus = () => {
    setRequestStatus({
      isLoading: false,
      done: false,
      name: "",
      data: null,
    });
  };

  return (
    <HzaContext.Provider
      value={{
        handleRequest,
        requestStatus,
        clearRequestStatus,
      }}
    >
      {children}
    </HzaContext.Provider>
  );
}
